















import Vue from 'vue';

export interface SubCategory {
  text: string;
  value: unknown;
}

export default Vue.extend({
  props: {
    value: Object as () => SubCategory,
    options: Array as () => Array<SubCategory>,
  },
  computed: {
    model: {
      get(): SubCategory {
        return this.value;
      },
      set(value: SubCategory): void {
        this.$emit('input', value);
      },
    },
  },
});
